import { type FC } from 'react';
import { cva } from 'class-variance-authority';
import cn from 'classnames';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { Light } from '@/components/ui/Light/Light';
import { Picture } from '@/components/ui/Picture/Picture';

import { imageConfigs } from './config';

import css from './styles.module.scss';

const aboutImageVariant = cva('', {
  variants: {
    image: {
      Grand: css.grandImage,
      GrandPlus: css.grandImage,
      Custom: css.customImage,
      Golden: css.goldenImage,
      GoldenPlus: css.goldenImage,
      Blitz: css.blitzImage,
      BlitzPlus: css.blitzImage,
    },
    light: {
      Grand: css.grandLight,
      GrandPlus: css.grandLight,
      Custom: css.customLight,
      Golden: css.goldenLight,
      GoldenPlus: css.goldenLight,
      Blitz: css.blitzLight,
      BlitzPlus: css.blitzLight,
    },
    shadow: {
      Grand: css.grandShadow,
      GrandPlus: css.grandShadow,
      Custom: css.customShadow,
      Golden: css.goldenShadow,
      GoldenPlus: css.goldenShadow,
      Blitz: css.blitzShadow,
      BlitzPlus: css.blitzShadow,
    },
  },
});

interface AboutImageProps {
  kind: SpecContractType | PaidSpecContractType;
}

const AboutImage: FC<AboutImageProps> = ({ kind }) => {
  const { image } = imageConfigs[kind];

  return (
    <>
      <Picture
        className={cn(
          'absolute left-1/2 -translate-x-1/2 z-[1]',
          aboutImageVariant({ image: kind }),
        )}
        {...image}
        alt={kind}
      />
      <Light
        className={cn(
          'absolute mix-blend-overlay',
          aboutImageVariant({ light: kind }),
        )}
      />
      <span
        className={cn('absolute', aboutImageVariant({ shadow: kind }))}
      ></span>
    </>
  );
};

export { AboutImage };
